<button 
	class="button" 
	[ngClass]="{'is-side-by-side' : INDRA_hasNextFlight() && INDRA_hasPreviousFlight()}" 
	(click)="INDRA_handlePrevious()" 
	[attr.aria-label]="INDRA_getAriaLabelTranslation('selectPreviousFlight') | ibeadmin:'sync'"
	*ngIf="INDRA_hasPreviousFlight()">
	{{ INDRA_getTextTranslation('selectPreviousFlight') | ibeadmin:'sync' }} <!-- not yet implemented -->
</button>
<button 
	class="button" 
	[ngClass]="{'is-side-by-side' : INDRA_hasNextFlight() && INDRA_hasPreviousFlight()}" 
	(click)="INDRA_handleNext()" 
	[attr.aria-label]="INDRA_getAriaLabelTranslation('selectNextFlight') | ibeadmin:'sync'"
	*ngIf="INDRA_hasNextFlight()">
	{{ INDRA_getTextTranslation('selectNextFlight') | ibeadmin:'sync' }}
</button>
